import { useStateParams } from '../../../../hooks/use-state-params';
import { PAYMENTS_QUERY_SEARCH_PARAM_KEY } from './use-query-input-param-consts';

export function useQueryInputParams() {
  return useStateParams<string | undefined>(
    undefined,
    PAYMENTS_QUERY_SEARCH_PARAM_KEY,
    (query) => query,
    (query) => query ?? undefined,
  );
}
